import { resolveSessionId } from './session';

import type { AnalyticsContextData } from './types';

import type { SiteConfigResponse } from '@/lib/api/types';

export const buildAnalyticsContext = (
  config: SiteConfigResponse,
): AnalyticsContextData => ({
  tenantId: config.configuration.tenant_id,
  siteId: config.id,
  sessionId: resolveSessionId(),
  muxDataKey: config.configuration.analytics?.mux ?? null,
});
